export enum PurchaseRequestTimelineEventType {
    Readied = 'Readied',
    Ordered = 'Ordered',
    Received = 'Received',
    NeedDate = 'Need date',
    ExpectedArrival = 'Expected arrival',
    Canceled = 'Canceled',
    Today = 'Today'
}